import React, {memo} from "react";
import styles from "@/app/components/button/styles.module.scss";
import classNames from "classnames";

interface ButtonProps {
  onClick?: () => void;
  isLoading?: boolean;
  isDisabled?: boolean;
  outline?: boolean;
  small?: boolean;
  children?: React.ReactNode;
  className?: string
}

const Button: React.FC<ButtonProps> = ({
                                         onClick = () => {
                                         },
                                         isLoading = false,
                                         isDisabled = false,
                                         outline = false,
                                         small = false,
                                         children = "Continue",
                                         className
                                       }) => {
  return (
    <button
      className={classNames(styles.button, {[styles.outline]: outline}, {[styles.loading]: isLoading}, {[styles.disabled]: isDisabled}, {[styles.small]: small}, className)}
      onClick={onClick}
      disabled={isDisabled || isLoading}
    >
      {isLoading ? (
        <div className={styles.spinner}></div>
      ) : (
        children
      )}
    </button>
  );
};

export default memo(Button);